import { createContext, useReducer, useState } from "react";
import {
  addToCartData,
  clearAppointmentData,
  clearCurrData,
  getCartData,
} from "hooks/useBookAppointment";
import { encryptData, secretKey } from "utils";

const BookAppointmentCartContext = createContext<any>({});

const cartReducer = (state: any, action: any) => {
  switch (action.type) {
    case "ADD_TO_CART":
      addToCartData(action.payload);
      return [...state, action.payload];

    case "REMOVE_FROM_CART":
      const existingData = getCartData();
      const updatedData = existingData.filter((item: any) => {
        return item.vaccineSelectedId !== action.payload.vaccineSelectedId;
      });
      sessionStorage.setItem("cart", encryptData(updatedData, secretKey));
      return state.filter(
        (item: any) =>
          item.vaccineSelectedId !== action.payload.vaccineSelectedId
      );

    case "CLEAR_CART":
      clearCurrData();
      clearAppointmentData();
      return [];

    default:
      return state;
  }
};

const BookAppointmentCartProvider = ({ children }: any) => {
  const cartData = getCartData();
  const [cart, dispatch] = useReducer(cartReducer, cartData || []);
  const [isCartOpen, setIsCartOpen] = useState(false);

  const openCart = () => {
    setIsCartOpen(true);
  };

  const closeCart = () => {
    setIsCartOpen(false);
  };

  return (
    <BookAppointmentCartContext.Provider
      value={{ cart, dispatch, isCartOpen, openCart, closeCart }}
    >
      {children}
    </BookAppointmentCartContext.Provider>
  );
};

export { BookAppointmentCartProvider, BookAppointmentCartContext };
